import Loader from 'components/Common/Loader';
import NoData from 'components/Common/NoData';
import React, {FC} from 'react';

import {TeaserWpArticle} from 'utils/types';

import './styles.scss';

interface Props {
  loading?: boolean;
  articles?: TeaserWpArticle[];
}

const WidgetTeaser: FC<Props> = ({loading, articles}: Props) => {
  /* eslint-disable react/jsx-no-target-blank */
  return (
    <section className="WidgetTeaser">
      <h3 className="WidgetTeaser__header">ΔΙΑΒΑΣΤΕ ΑΚΟΜΑ</h3>{' '}
      {/* TODO: dynamic title from feed group name */}
      {(!articles || !articles.length) && loading && <Loader />}
      {!articles || !articles.length ? (
        <NoData />
      ) : (
        articles.map(
          ({post_url, post_title, post_image, post_tags, post_tags_slugs, post_date}, i) =>
            /* TODO: fallback image */ post_image && (
              <article
                className={`WidgetTeaser__article ${
                  i === 0 ? 'WidgetTeaser__article--big' : 'WidgetTeaser__article--small'
                }`}
                key={`${i + Math.random()}`}
              >
                <figure className="WidgetTeaser__image">
                  <a href={post_url} target="_blank">
                    <img
                      src={ post_image
                        // i === 0
                        //   ? image.url.replace(/\/(w?)620(?=\/)/g, '/$1380')
                        //   : image.url.replace(/\/(w?)620(?=\/)/g, '/$1140')
                      }
                      alt="caption"
                    />
                  </a>
                </figure>
                <div className="WidgetTeaser__meta">
                  {(post_tags && post_tags_slugs) && (
                    <a className="WidgetTeaser__tag" href={`/tag/${post_tags_slugs[0]}`} target="_blank">
                      {post_tags[0]}
                    </a>
                  )}
                  <a className="WidgetTeaser__title" href={post_url} target="_blank">
                    {post_title}
                  </a>
                  <span className="WidgetTeaser__date">
                    <span>{post_date.toLocaleDateString('de-DE')}</span>
                    <span>
                      {post_date.toLocaleTimeString('el-GR', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      })}
                    </span>
                  </span>
                </div>
                {/* {impressionUrl && (
                  <img
                    src={impressionUrl}
                    alt="impression"
                    style={{display: 'none', position: 'absolute'}}
                  />
                )} */}
              </article>
            )
        )
      )}
    </section>
  );
};

export default React.memo(WidgetTeaser);
